import axios from "axios";

export default axios.create({
  baseURL: "https://www.googleapis.com/",
  params: {
    prettyPrint: false,
    maxResults: 10,
    key: "AIzaSyBhE_hdSZP_Hv5OsznNukArYPXmMIHIdjo",
  },
});
